import React from "react";
import "./spinner.css";

function SpinnerShow() {
  return <div className="loader"></div>;
}
export default SpinnerShow;
